import { useCallback } from "react";

import { useDayTripPlanEditMutation } from "../../../../../repository/new";

import type { ProductDayTripPlanFormModel } from "../../../../../type";

type Props = {
	reset: () => void;

	viewModel: ProductDayTripPlanFormModel["ViewModel"];
};

export const useUpdatePlan = ({ reset, viewModel }: Props) => {
	const { onUpdatePlan: _onUpdatePlan } = useDayTripPlanEditMutation({ reset });

	const onUpdatePlan = useCallback(async () => {
		await _onUpdatePlan({ ...viewModel });
	}, [_onUpdatePlan, viewModel]);

	return {
		onUpdatePlan,
	};
};
